// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.settingsHint[data-v-68f8b994] {
  margin-top: 0;
  opacity: 0.9;
}
.settingsHint p[data-v-68f8b994] {
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/SettingsSection.vue"],"names":[],"mappings":";AA2BA;EACA,aAAA;EACA,YAAA;AACA;AAEA;EACA,mBAAA;AACA","sourcesContent":["<script>\r\nimport NcSettingsSection from '@nextcloud/vue/dist/Components/NcSettingsSection.js'\r\nexport default {\r\n  name: 'SettingsSection',\r\n  components: {\r\n    NcSettingsSection,\r\n  },\r\n  props: {\r\n    title: {\r\n      type: String,\r\n      default: '',\r\n    },\r\n  },\r\n};\r\n</script>\r\n\r\n<template>\r\n  <NcSettingsSection\r\n      :name=\"title\">\r\n    <div class=\"settings-hint settingsHint\">\r\n      <slot name=\"settingsHint\" />\r\n    </div>\r\n    <slot />\r\n  </NcSettingsSection>\r\n</template>\r\n\r\n<style scoped>\r\n.settingsHint {\r\n  margin-top: 0;\r\n  opacity: 0.9;\r\n}\r\n\r\n.settingsHint p {\r\n  margin-bottom: 10px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
